import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext } from 'react';
import { useLocalStorage } from '@lib/hooks';
import { Country, Currency, getUserTimeZone, isWidget, Tip } from '@lib/services';
import { CampaignSetup } from '../campaignSetup';
export const EverGivePercentage = [0, 25, 50, 100];
export var SplitType;
(function (SplitType) {
    SplitType["Equally"] = "equally";
    SplitType["MoreOdd"] = "more-odd";
    SplitType["More27"] = "more-27";
    SplitType["MoreArafah"] = "more-arafah";
    SplitType["NotSelected"] = "not-selected";
    SplitType["MoreLastTenOddNights"] = "more-10-odd-nights";
})(SplitType || (SplitType = {}));
export var NightTypeOpt;
(function (NightTypeOpt) {
    NightTypeOpt["AllAvailable"] = "allAvailable";
    NightTypeOpt["LastTenAvailable"] = "lastTenAvailable";
})(NightTypeOpt || (NightTypeOpt = {}));
export const mtnSplitTexts = {
    [SplitType.Equally]: 'Split equally',
    [SplitType.MoreOdd]: 'More on odd nights',
    [SplitType.More27]: 'More on 27th',
    [SplitType.MoreLastTenOddNights]: 'More on last 10 odd nights'
};
export const mtdSplitTexts = {
    [SplitType.Equally]: 'Split Equally',
    [SplitType.MoreArafah]: 'More on Arafah'
};
export var Multiplier;
(function (Multiplier) {
    Multiplier[Multiplier["OnePointFive"] = 1.5] = "OnePointFive";
    Multiplier[Multiplier["Double"] = 2] = "Double";
    Multiplier[Multiplier["Triple"] = 3] = "Triple";
})(Multiplier || (Multiplier = {}));
export const defaultCharity = {
    about: '',
    registration_number: '',
    campaign: '',
    causes: [],
    selectedCauses: [],
    charity_id: '',
    charity_name: '',
    country: Country.GB,
    currency: Currency.GBP,
    gift_aid: false,
    privacy_policy_url: '',
    tax_receipt: false,
    partner: ''
};
export var CampaignDates;
(function (CampaignDates) {
    CampaignDates[CampaignDates["FirstNight"] = 20] = "FirstNight";
    CampaignDates[CampaignDates["StartDateOffset"] = 0] = "StartDateOffset";
})(CampaignDates || (CampaignDates = {}));
export const getDefaultPlan = () => {
    const tz = getUserTimeZone();
    return {
        campaign: CampaignSetup.currentCampaign,
        causes: {},
        selectedCauses: [],
        chainCode: '',
        chainCodeCharity: defaultCharity,
        charity: defaultCharity,
        detectedTimezone: tz,
        firstNight: 0,
        multiplier: Multiplier.Double,
        night30: true,
        split: SplitType.NotSelected,
        totalNight: { key: '', value: 0 },
        fridayGiving: 0,
        fridayGivingOptIn: '',
        wakf: 0,
        wakfOptIn: '',
        emailOptIn: true,
        charityEmailOptIn: false,
        timezone: tz !== '' ? tz : 'Europe/London',
        donorDetails: {
            addressLine1: '',
            country: '',
            email: '',
            firstName: '',
            lastName: '',
            houseNumber: '',
            postalCode: '',
            isAddressFromLookup: false
        },
        paymentDetails: {
            giftAid: false,
            taxReceipt: false,
            payFees: true,
            tipPercent: Tip.TenPercent,
            tipValue: 0,
            payTip: true
        },
        startDateOffset: CampaignDates.StartDateOffset,
        autoEnroll: 'true',
        evergiveSharePercentage: null,
        egContributionOptIn: false
    };
};
const checkoutPlanContext = createContext({
    plan: getDefaultPlan(),
    setPlan: (p) => console.log(p),
    resetPlan: () => { },
    setCharity: (c) => console.log(c)
});
export const useCheckoutPlan = () => {
    const result = useContext(checkoutPlanContext);
    if (result.plan.campaign !== CampaignSetup.currentCampaign) {
        result.resetPlan();
    }
    return result;
};
export const CheckoutPlanProvider = ({ children }) => {
    const [plan, setPlan] = useLocalStorage('checkout_plan', getDefaultPlan());
    const setCharity = (charity) => {
        const causes = plan.charity.charity_id === charity.charity_id ? plan.causes : {};
        setPlan(Object.assign(Object.assign({}, plan), { charity, causes, selectedCauses: [] }));
    };
    const resetPlan = useCallback(() => {
        if (isWidget) {
            setPlan(Object.assign(Object.assign({}, getDefaultPlan()), { charity: plan.charity }));
            return;
        }
        setPlan(getDefaultPlan());
    }, [setPlan, plan.charity]);
    const value = {
        plan,
        setPlan,
        resetPlan,
        setCharity
    };
    return _jsx(checkoutPlanContext.Provider, Object.assign({ value: value }, { children: children }));
};
//# sourceMappingURL=data:application/json;base64,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